export default __webpack_public_path__ + "static/media/ico_slash.da2d7b2f.svg";